import { Component } from '@angular/core';
import { AddressContainerComponent } from '../address-container/address-container.component';

@Component({
  selector: 'editable-address-container',
  templateUrl: './editable-address-container.component.html',
  styleUrls: ['./editable-address-container.component.sass'],
})
export class EditableAddressContainerComponent extends AddressContainerComponent {
  delete(index: number) {
    this.addressArray.splice(index, 1);
  }
}
